import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useTitle } from 'shared/hooks';
import { ProvideTableData, createTableDataContext } from 'shared/providers/provideTableData';
import { DistributorsData } from 'types/backend';
import { DistributorManagement } from './distributorManagement';

export const distributorsContext = createTableDataContext<DistributorsData>();
const ManagePricingResolver = React.lazy(() => import('pages/managePricing/managePricingResolver'));
export const defaultDistributorsConfig: {initialState?: GridInitialStatePremium} | undefined = {
    initialState: {
        sorting: {
            sortModel: [
                {
                    field: 'customerName',
                    sort: 'asc',
                },
            ],
        },
        pinnedColumns: {
            left: ['customerName']
        },
        pagination: {
            paginationModel: {
                page: 0,
                pageSize: 100,
            },
        }
    },
}
export default function DistributorManagementResolver() {
    useTitle(`Distributor Management - Paragon`);
    
    return (
        <ProvideTableData name='Distributors' tableDataContext={distributorsContext} config={defaultDistributorsConfig}>
            <Switch>
                <Route path={ROUTES.managePricing}>
                    <ManagePricingResolver />
                </Route>
                <Route exact path={ROUTES.distributorManagement}>
                    <DistributorManagement />
                </Route>
            </Switch>
        </ProvideTableData>
    );
}
